import { utils, write } from '@sheet/core'

export default (items: any, orderOfHeaders: string[] = []) => {
  const newOrderOfHeaders = [...orderOfHeaders]
  const workbook = utils.book_new()
  const sheet = utils.json_to_sheet(items, { header: newOrderOfHeaders, cellDates: true })
  utils.book_append_sheet(workbook, sheet)
  return new Blob([write(workbook, { type: 'array', bookType: 'xlsx' })])
}
